/*
 * Project: bellcloud
 * File: packages/protocols/mini/fn_monitoring.ts
 * Author: SWAN
 * Created: 2025-01-27
 * Description: ClassID.MONITORING (0x02)에 대한 FunctionID별 파라미터 정의
 */
import type { FunctionParameter } from '../fns';

export const params_monitoring: Record<number, FunctionParameter[]> = {
  0x01: [], // Request gas readings and status - no parameters
  0x02: [
    {
      name: 'system_status',
      type: 'u16',
      bytes: 2,
      comment: 'See below instrument status',
      format: 'enum_system_status',
    },
    {
      name: 'timestamp',
      type: 'u32',
      bytes: 4,
      comment: 'Seconds since 2023.01.01',
      format: 'date_seconds_from_basedate',
    },
    {
      name: 'temperature',
      type: 's16',
      bytes: 2,
      comment: 'x 10 degC',
      format: 'temperature',
    },
    {
      name: 'gas_conc',
      type: 's32',
      bytes: 4,
      comment: 'x 1000 concentration',
      format: 'gas_concentration',
    },
    {
      name: 'error_code',
      type: 'u8',
      bytes: 1,
      comment: 'Error code, see below',
      format: 'enum_error_code',
    },
    {
      name: 'warning_code',
      type: 'u8',
      bytes: 1,
      comment: 'Warning code, see below',
      format: 'enum_warning_code',
    },
  ],
};
